/**
 * playbookRole - who can do what in the CAR-T Playbook, on the client.
 *
 * Client change (Oct 2026, feedback #14): a Medical Advisor (role "sales" with
 * the sub-type "Medical Advisor") uses the planner: view, add and edit cases
 * for the hospitals of their area, adding a patient for a physician of that
 * area; no archive. Other sales users have no access. The server decides the
 * same way (playbook.routes.js / playbook.permissions.js) and is the authority;
 * this only drives what the screens show.
 */
export const MEDICAL_ADVISOR = 'medical_advisor';
const MEDICAL_ADVISOR_SUB_TYPE = 'Medical Advisor';

/** The user's planner role: their role, or 'medical_advisor'. */
export function playbookRole(user) {
  if (!user) return null;
  if (user.role === 'sales' && user.sub_type === MEDICAL_ADVISOR_SUB_TYPE) return MEDICAL_ADVISOR;
  return user.role;
}

const OPENS = ['physician', 'superadmin', 'stakeholder', MEDICAL_ADVISOR];

/** Can open the CAR-T Playbook at all. */
export const canOpenPlaybook = (user) => OPENS.includes(playbookRole(user));

/** Adds patients and edits cases. */
export const canWritePlaybook = (user) => ['physician', MEDICAL_ADVISOR].includes(playbookRole(user));

/** Archives cases (physicians only). */
export const canArchivePlaybook = (user) => playbookRole(user) === 'physician';

/** Adds a patient for a physician, chosen in Add Patient. */
export const addsPatientsForPhysician = (user) => playbookRole(user) === MEDICAL_ADVISOR;
